import { useGetResources } from '../../../hooks/member-area/use-get-resources'
import { GroupsTable } from './components/groups-table'

type Props = {
  offerId?: string
}

export const Groups: React.FC<Props> = ({ offerId }) => {
  const { data = [], isLoading } = useGetResources(offerId)

  return (
    <div className="flex flex-col my-4 gap-3">
      <GroupsTable offerId={offerId} data={data} isLoading={isLoading} />
    </div>
  )
}
